/**
 * 兑换码管理 API
 *
 * 提供兑换码批次的 CRUD 操作
 */

import httpRequest from '@/utils/api'

enum API {
  batches = '/admin/redeem-code/batches',
  codes = '/admin/redeem-code/codes',
}

export interface CreateBatchPayload {
  pricingId: number
  totalCount: number
  expiresAt?: string
  remark?: string
}

/**
 * 创建兑换码批次
 *
 * @param data 创建批次请求数据
 * @returns 批次创建响应
 */
export const createBatchAPI = (data: CreateBatchPayload) => {
  return httpRequest.post({
    url: API.batches,
    data,
  })
}

/**
 * 获取批次列表
 *
 * @param skip 跳过数量
 * @param limit 返回数量
 * @returns 批次列表响应
 */
export const getBatchListAPI = (skip: number = 0, limit: number = 20) => {
  return httpRequest.get({
    url: API.batches,
    params: { skip, limit },
  })
}

/**
 * 获取批次详情
 *
 * @param batchId 批次 ID
 * @returns 批次详情响应
 */
export const getBatchDetailAPI = (batchId: number) => {
  return httpRequest.get({
    url: `${API.batches}/${batchId}`,
  })
}

/**
 * 获取批次的兑换码列表
 *
 * @param batchId 批次 ID
 * @param skip 跳过数量
 * @param limit 返回数量
 * @returns 兑换码列表响应
 */
export const getBatchCodesAPI = (
  batchId: number,
  skip: number = 0,
  limit: number = 20
) => {
  return httpRequest.get({
    url: `${API.batches}/${batchId}/codes`,
    params: { skip, limit },
  })
}

/**
 * 导出兑换码
 *
 * @param batchId 批次 ID
 * @param format 导出格式：csv 或 txt
 * @returns 文件流
 */
export const exportCodesAPI = (batchId: number, format: string = 'csv') => {
  return httpRequest.get<Blob>({
    url: `${API.batches}/${batchId}/export`,
    params: { format },
    responseType: 'blob',
  }) as unknown as Promise<Blob>
}

/**
 * 禁用兑换码
 *
 * @param codeId 兑换码 ID
 * @returns 禁用结果响应
 */
export const disableCodeAPI = (codeId: number) => {
  return httpRequest.post({
    url: `${API.codes}/${codeId}/disable`,
  })
}
